module.exports = __webpack_public_path__ + "img/i-content-admin.48a0eff1.svg";